import React, { useState, useEffect } from "react";
import Image from "../../components/common/Image";
import Select from "../../components/common/Select";
import Input from "../../components/common/Input";
import Notification from "../../components/common/Error/Notification";
import { useSelector, useDispatch } from "react-redux";
import { GetOfferDetailSub, GetOfferDetail, GetGetByRandomId } from "../../api/offer";
import { updateIdentities,updateInfo } from "../../store/userSlice";
import moment from 'moment'
import { useSearchParams } from "react-router-dom";

const Step1 = ({ setStep, navigate, identities }) => {
  const dispatch = useDispatch()
  //0: disabled ；1: 可點擊； 2:資料送出中，不可點擊
  const parameters = useSelector((state) => state.global.parameters);
  // const userId = useSelector((state) => state);
  const [btnState, setBtnState] = useState(0);
  const [selection, setSelection] = useState({
    OfferDetailType: null,
    car_no: "",
    coupon_number: ""
  });
  const [queryParameters] = useSearchParams()
  const randomId = queryParameters.get("randomId")
  const [identitySelect, setIdentitySelect] = useState(false);
  useEffect(() => {
    if (identitySelect === 0) {
      document.querySelector("body").style.overflow = "hidden";
    } else {
      document.querySelector("body").style.overflow = "unset";
    }
  }, [identitySelect]);
  const fetchID = async ()=>{
    let OfferDetailType = parameters?.OfferDetailType.data
    let res = await GetGetByRandomId({ randomId })
    if (res?.result && res?.statusCode === 200) {
          const { tmsOfferPno,tmsOfferCust,plateNum } = res.result
          let filter = OfferDetailType.filter(o=>o.value === tmsOfferPno)
            let obj={
              car_no : plateNum,
              OfferDetailType : filter[0],
              info:res.result
            }
          
            if(tmsOfferPno !=='6'){
              let sub = await GetOfferDetailSub({ OfferType: filter[0]['value'] });

              if (sub.statusCode === 200) {
                obj.options = sub.result;
                let sub_filter = sub.result.filter(s=>s.id ===tmsOfferCust)
                obj.option = sub_filter[0]

              }
            }else{
              //優惠券
              obj.offer_cust = tmsOfferCust
            }
          setSelection(obj)
          submitData(obj)
    }else{
      setIdentitySelect({error : res.message})
    }
  }
  useEffect(() => {
    if (randomId && parameters) {
      fetchID()
    }
  }, [randomId,parameters])
  useEffect(() => {
    reformData("change")
  }, [selection]);

  const reformData = (type, id) => {
    let obj = {}
    let select = id?id: selection
    if (select.OfferDetailType) {
      obj.offer_type = select.OfferDetailType.value
    }
    if (select.OfferDetailType?.name) {
      if (select.offer_cust && select.OfferDetailType?.id === 6) {
        obj.offer_cust = select.offer_cust
      }
      if (select.option) {
        obj.offer_cust = select.option.id
      }
    }
    if (select.car_no) {
      obj.car_no = select.car_no
    }
    // if(selection.coupon_number){
    //     obj.coupon_number = selection.coupon_number
    // }
    if (type) {
      let num = obj.offer_type === 7 ? 2 : 3
      setBtnState(Object.keys(obj).length === num ? 1 : 0)
    }

    return obj
  }


  const selectionFn = async (data, key) => {
    let obj = {};
    if (key === "OfferDetailType") {
      let res = await GetOfferDetailSub({ OfferType: data.value });
      if (res.statusCode === 200) {
        obj.options = res.result;
      }
      else {
      }
    } else {
      obj = { ...selection };
    }
    obj[key] = data;

    setSelection(obj);
  };

  const submitData = async (id) => {
    if (!randomId && btnState !== 1) return false;
    setBtnState(2)
    let obj = id ? reformData(null,id):reformData()
    let res = await GetOfferDetail(obj)
    if (res && res.statusCode === 200) {
      if (res.result === "無此優惠權益，請洽客服中心") {
        setIdentitySelect({error:res.result})
      } else {
        setIdentitySelect(false)
        // let ids = identities ? [...identities.ids] : []
        let ids =  []
        let obj = {
          ...selection,
          ...id,
          data: res.result.right_list

        }
   
        // let index
        // if (ids.length > 0) {
        //   ids.map((d, i) => {
        //     if (d.OfferDetailType.id === obj.OfferDetailType.id &&
        //       d.car_no === obj.car_no &&
        //       d.offer_cust === obj.offer_cust) {
        //       index = i
        //     } else {
        //       index = -1
        //     }
        //   })
        // } else {
        //   index = -1
        // }
        // if (index === -1) {
        //   ids.push(obj)
        // } else {
        //   ids[index] = obj
        // }
        
        // ids.push({
        //   list:res.result.right_list, 
        //   car_no:obj.car_no,
        //   OfferDetailType:obj.OfferDetailType})
          ids.push(obj)

        // //存入localstorage
        if(randomId) dispatch(updateInfo(null)) //帶入優惠身分
        dispatch(updateIdentities({ date: moment(), ids }))
        navigate("/identity?key=2")
      }
    } else {

    }

  }
  return (
    <>
      <div className="grid-gap-24">
        {/* <button className="w-full btn-outline">
          <div className="d-flex">
            <Image src="/images/LINE.png" />
            <div>
              我是全鋒大平台會員，
              <br />
              透過 Line 快速帶入優惠身份。
            </div>
          </div>
        </button> */}
        {/* <div className="line-text-center">
          <p>或輸入相關內容帶入</p>
        </div> */}
        <Select
          placeholder="點擊選擇您要新增的優惠類型"
          defaultValue={selection.OfferDetailType}
          options={parameters?.OfferDetailType.data}
          onChange={(data) => {
            selectionFn(data, "OfferDetailType");
          }}
        />
        {selection.OfferDetailType && (
          <>
            {selection.OfferDetailType?.id < 6 && (
              <Select
                label={
                  selection.OfferDetailType?.id === 5
                    ? "客戶別"
                    : selection.OfferDetailType?.value === "7"?'類別':`${selection.OfferDetailType?.name}別`
                }
                placeholder="點擊選擇"
                options={selection.options}
                defaultValue={selection?.option}
                onChange={(data) => selectionFn(data, "option")}
              />
            )}
            <Input
              defaultValue={selection.car_no}
              label="車牌號碼"
              placeholder="不需輸入”-”，例）ABC123"
              rules={
                [{ pattern: new RegExp(/^[A-Z0-9]*$/), message: '請輸入半形大寫英文與數字，不需包含「-」符號。' }]
              }
              onChange={(val) => {
                selectionFn(val, "car_no")
              }}
            />
            {selection.OfferDetailType?.id === 6 && (
              <Input label="優惠碼"
                defaultValue={selection.offer_cust}
                placeholder="輸入您的優惠序號"
                onChange={(val) => {
                  selectionFn(val, "offer_cust")
                }}
              />
            )}
          </>
        )}
      </div>
      <button className={`btn ${btnState === 2 ? 'btn-cursor-disabled' : ''}`} disabled={!btnState}
        onClick={()=>submitData()}
      >
        {btnState === 2 && <Image src="/images/icons/loader.svg" />}
        <p>帶入{btnState === 2 && "優惠中"}</p>
      </button>
      {identitySelect.error && (
        <Notification
          // title={identitySelect.error}
          // description="請確認內容後再試一次"
          description='無此優惠權益，若您需要救援服務，請您改點「沒有優惠身份」提供道路救援資訊，上傳後將有客服人員與您聯繫。'
          onConfirm={() => {
            if(!randomId){setBtnState(1) }
            setIdentitySelect(false)
          }}
        />
      )}
    </>
  );
};

export default Step1;
